import { useAppSelector } from 'app/hooks'
import Layout from 'components/Layout'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { authRoutes, privateRoutes, publicRoutes } from './routes'

function App() {
  const auth = useAppSelector((s) => s.UI.auth)
  const statusUI = useAppSelector((s) => s.UI.status)
  const location = useLocation()
  const urlQuery = new URLSearchParams(useLocation().search)
  const from = (location.state as any)?.from?.pathname || `/?${urlQuery}`
  return (
    <Layout>
      <Routes>
        {privateRoutes.map((v, i) => {
          return (
            <Route
              key={i}
              path={v.path}
              element={
                statusUI !== 'init' ? (
                  auth ? (
                    <v.element />
                  ) : (
                    <Navigate to={`/login/?${urlQuery}`} state={{ from: location }} replace />
                  )
                ) : (
                  <h2>Loading...</h2>
                )
              }
            />
          )
        })}
        {authRoutes.map((v, i) => {
          return (
            <Route
              key={i}
              path={v.path}
              element={
                statusUI !== 'init' ? (
                  !auth ? (
                    <v.element />
                  ) : (
                    <Navigate to={from} replace />
                  )
                ) : (
                  <h2>Loading...</h2>
                )
              }
            />
          )
        })}
        {publicRoutes.map((v, i) => {
          return <Route key={i} path={v.path} element={<v.element />} />
        })}
      </Routes>
    </Layout>
  )
}

export default App
